import { render, staticRenderFns } from "./PlusIconNew.vue?vue&type=template&id=ddc91810"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ddc91810')) {
      api.createRecord('ddc91810', component.options)
    } else {
      api.reload('ddc91810', component.options)
    }
    module.hot.accept("./PlusIconNew.vue?vue&type=template&id=ddc91810", function () {
      api.rerender('ddc91810', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/PlusIconNew.vue"
export default component.exports